import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DealerResultsStyles from './DealerResults.styled';
import DealerCard from '../Shared/DealerCard';

const DealerResults = ({ results = [], error }) => {
  return (
    <DealerResultsStyles>
      <div className='inner'>
        {error && <p className='type-h2'>{error}</p>}
        {results.length > 0 &&
          !error &&
          results.map((props, i) => (
            <DealerCard
              {...props}
              style={{ animationDelay: `${(i % 4) * 0.1}s` }}
            />
          ))}
      </div>
    </DealerResultsStyles>
  );
};

DealerResults.propTypes = {
  results: PropTypes.array,
};

export default DealerResults;
